import axios from "axios";
import useSWR from "swr";

async function fetcher(url) {
  let page = 1;
  let results = [];
  let response, totalPages;
  response = await axios
    .get(url + "&page=" + page)
    .catch((err) => console.error(err));
  totalPages = response.headers["x-wp-totalpages"];
  results = results.concat(response.data);
  if (page < totalPages) {
    for (let i = page + 1; i <= totalPages; i++) {
      response = await axios
        .get(url + "&page=" + i)
        .catch((err) => console.error(err));
      results = results.concat(response.data);
    }
  }
  // split the set between regular items and items that should always be listed at the end of the list
  // the order between items comes from the original query and should be preserved
  const bottomStack = results?.filter((c) => c?.acf?.sticky_end) || [];
  let sortedResults = results?.filter((c) => !c?.acf?.sticky_end) || [];

  return [].concat(sortedResults, bottomStack).map((c) => {
    return {
      name: c.name,
      id: c.id,
      sticky_end: c?.acf?.sticky_end ?? false,
    };
  });
}

const useCompanies = () => {
  const { data: companies, error } = useSWR(
    `${window?.__env__?.WP_SOURCE}/wp-json/wp/v2/gpi-company?order=asc&orderby=name&_fields=id,name,acf&hide_empty=true`,
    fetcher
  );
  return { companies, error, loading: !error && !companies };
};

export default useCompanies;
